import React, { Component } from 'react';
import { connect } from 'react-redux';

import notSure from '../../assets/images/notsure.png';

import { actions } from '../actions/user';
import { isHighestLevel } from '../factories/StatFactory';
import User from '../components/User';

class UserList extends Component {
  componentDidMount() {
    const { loadUsers } = this.props;
    loadUsers();
  }

  render() {
    const { isFetching, removeUser, results, sort } = this.props;

    if (isFetching) {
      return results.length > 0 ?
        <div className="row">
          {results.map(user => (
            <User key={user.id} name={user.name} user={user} sort={sort} handleRemove={removeUser} />
          ))}
        </div> :
        <div className="push-top-4x text-center">
          <div className="notsure-wrapper"><img className="notsure" src={notSure} alt="Wut u doin bro?" /></div>
          <p><strong>No Users, Why Not Add One?</strong></p>
        </div>;
    }

    return (
      <div className="row">
        {results.map(user => (
          <User key={user.id} name={user.name} user={user} sort={sort} superiorCheck={isHighestLevel(results)} handleRemove={removeUser} />
        ))}
      </div>
    );
  }
}

const mapStateToProps = ({ app, users }) => ({
  sort: app.sort,
  isFetching: users.isFetching,
  results: users.results,
});

export default connect(
 mapStateToProps,
 actions
)(UserList);



// WEBPACK FOOTER //
// ./src/containers/UserList.js